import { Directive, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';
@Directive({
  selector: '[spaceTrimDirective]'
})
export class SpaceTrimDirective {
  @Input() onlyOneSpaceAllowed: string;
  @Input() startWithZero: any;
  constructor(private control: NgControl) { }
  @HostListener('input', ['$event'])
  @HostListener('textarea', ['$event'])
  onEvent() {
    if (this.onlyOneSpaceAllowed) {
      this.forFirstNameTrim();
    }
    else {
      this.forAllInputType();
    }
  }
  forFirstNameTrim() {
    const abstractControl = this.control.control;
    if (abstractControl.value.startsWith(' ')) {
      let value = abstractControl.value.replace(/ +/g, '');
      abstractControl.setValue(value);
    }
    if (abstractControl.value.endsWith(' ')) {
      let value = abstractControl.value.replace(/ +/g, ' ');
      abstractControl.setValue(value);
    }
  }
  forAllInputType() {
    const abstractControl = this.control.control;
    if (this.startWithZero) {
      if (abstractControl.value == 0) {
        let value = abstractControl.value.replace(0, '');
        abstractControl.setValue(value);
      }
    }
    let value = abstractControl.value.replace(/ +/g, '')
    abstractControl.setValue(value);
  }
}
